const REVIEWS_HASH = '#reviews';
const SCROLL_DURATION = 500;
const EXTRA_OFFSET_REM = 2;
const REVIEWS_SCROLL_TARGET = 'reviews';
const PENDING_SCROLL_KEY = 'evasota:pending-scroll-target';

function getReviewsTarget() {
  return document.getElementById('reviews');
}

function getCleanLocation() {
  return `${window.location.pathname}${window.location.search}`;
}

function getExtraOffset() {
  const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;

  return rootFontSize * EXTRA_OFFSET_REM;
}

function getHeaderOffset() {
  const header = document.querySelector('.header');

  return header ? header.getBoundingClientRect().height : 0;
}

function getTargetScrollTop(target) {
  const top = target.getBoundingClientRect().top + window.scrollY;
  const offset = getHeaderOffset() + getExtraOffset();

  return Math.max(top - offset, 0);
}

function easeInOutCubic(progress) {
  return progress < 0.5
    ? 4 * progress * progress * progress
    : 1 - Math.pow(-2 * progress + 2, 3) / 2;
}

function animateScrollTo(targetTop) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.scrollTo(0, targetTop);
    return;
  }

  const startTop = window.scrollY;
  const delta = targetTop - startTop;

  if (Math.abs(delta) < 1) {
    window.scrollTo(0, targetTop);
    return;
  }

  const startedAt = performance.now();

  const step = (now) => {
    const progress = Math.min((now - startedAt) / SCROLL_DURATION, 1);
    const easedProgress = easeInOutCubic(progress);

    window.scrollTo(0, startTop + delta * easedProgress);

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  };

  requestAnimationFrame(step);
}

function scrollToReviews() {
  const target = getReviewsTarget();

  if (!target) {
    return;
  }

  animateScrollTo(getTargetScrollTop(target));
}

function setPendingScrollTarget(target) {
  sessionStorage.setItem(PENDING_SCROLL_KEY, target);
}

function consumePendingScrollTarget() {
  const target = sessionStorage.getItem(PENDING_SCROLL_KEY);

  if (target) {
    sessionStorage.removeItem(PENDING_SCROLL_KEY);
  }

  return target;
}

function normalizePathname(pathname) {
  const normalized = pathname.replace(/\/+$/, '');

  return normalized || '/';
}

function isCurrentPage(url) {
  return url.origin === window.location.origin
    && normalizePathname(url.pathname) === normalizePathname(window.location.pathname)
    && url.search === window.location.search;
}

function isReviewsLink(link, url) {
  return link.dataset.scrollTo === REVIEWS_SCROLL_TARGET || url.hash === REVIEWS_HASH;
}

function handleReviewsClick(event) {
  const link = event.target.closest('a[href]');

  if (!link) {
    return;
  }

  const url = new URL(link.href, window.location.href);

  if (!isReviewsLink(link, url)) {
    return;
  }

  if (isCurrentPage(url)) {
    event.preventDefault();
    history.replaceState(null, '', getCleanLocation());
    scrollToReviews();
    return;
  }

  event.preventDefault();
  setPendingScrollTarget(REVIEWS_SCROLL_TARGET);
  window.location.assign(`${url.origin}${url.pathname}${url.search}`);
}

function runInitialReviewsScroll() {
  const pendingScrollTarget = consumePendingScrollTarget();

  if (pendingScrollTarget !== REVIEWS_SCROLL_TARGET && window.location.hash !== REVIEWS_HASH) {
    return;
  }

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  history.replaceState(null, '', getCleanLocation());
  window.scrollTo(0, 0);

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      scrollToReviews();
    });
  });
}

export default function initReviewsAnchor() {
  document.addEventListener('click', handleReviewsClick);

  if (document.readyState === 'complete') {
    runInitialReviewsScroll();
    return;
  }

  window.addEventListener('load', runInitialReviewsScroll, { once: true });
}
